const LOCALE_BY_CURRENCY = { USD: "en-US", EUR: "de-DE", TRY: "tr-TR" };

export function formatPrice(amount, currency = "USD") {
  if (amount === null || amount === undefined || isNaN(amount)) return "";
  try {
    return new Intl.NumberFormat(LOCALE_BY_CURRENCY[currency] || "en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(Number(amount));
  } catch {
    return `${amount} ${currency}`;
  }
}

export function discountPercent(regular, sale) {
  const r = Number(regular);
  const s = Number(sale);
  if (!r || !s || s >= r) return 0;
  return Math.round(((r - s) / r) * 100);
}
